document.addEventListener('DOMContentLoaded', () => {
	const faqCards = document.querySelectorAll('.faq-card')
	faqCards.forEach((card) => {
		const trigger = card.querySelector('.faq-card__trigger')
		const answer = card.querySelector('.faq-card__answer')
		if (!trigger || !answer) return

		const setAnswerHeight = () => {
			card.style.setProperty('--text-height', `${answer.scrollHeight}px`)
		}
		setAnswerHeight()

		const toggle = () => {
			const isOpen = card.classList.toggle('open')
			trigger.setAttribute('aria-expanded', isOpen)
			answer.setAttribute('aria-hidden', !isOpen)
		}

		trigger.addEventListener('click', () => {
			toggle()
		})

		trigger.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault()
				toggle()
			}
		})
	})

	window.addEventListener('resize', () => {
		faqCards.forEach((card) => {
			const answer = card.querySelector('.faq-card__answer')
			if (!answer) return
			card.style.setProperty('--text-height', 'auto')
			card.style.setProperty('--text-height', `${answer.scrollHeight}px`)
		})
	})
})
